export const NODE_BG_COLORS: Record<string, { label: string; value: string }> = {
  default:  { label: 'Default',  value: '#141414' },
  purple:   { label: 'Purple',   value: '#2A1550' },
  teal:     { label: 'Teal',     value: '#0C3535' },
  blue:     { label: 'Blue',     value: '#0F1F3D' },
  rose:     { label: 'Rose',     value: '#3D1525' },
  amber:    { label: 'Amber',    value: '#3D2E0A' },
  emerald:  { label: 'Emerald',  value: '#0F3520' },
  slate:    { label: 'Slate',    value: '#252830' },
  indigo:   { label: 'Indigo',   value: '#1E1845' },
  olive:    { label: 'Olive',    value: '#2A3012' },
}

export const NODE_BG_SWATCH_COLORS: Record<string, string> = {
  default:  '#555555',
  purple:   '#7C3AED',
  teal:     '#14B8A6',
  blue:     '#3B82F6',
  rose:     '#F43F5E',
  amber:    '#F59E0B',
  emerald:  '#10B981',
  slate:    '#64748B',
  indigo:   '#6366F1',
  olive:    '#84CC16',
}

export function resolveNodeBgColor(colorKey: string | undefined): string {
  return NODE_BG_COLORS[colorKey ?? 'default']?.value ?? NODE_BG_COLORS['default'].value
}
